import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}categories`;

// const token = localStorage.getItem('token');

export const getCategoriess = async () => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}`, {
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const getCategoriesById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/${id}`, {
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const createCategories = (categories) => {
    const token = localStorage.getItem('token');

    return axios.post(`${API_URL_WEB}`, categories, {
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const updateCategories = (id, categories) => {
    const token = localStorage.getItem('token');

    return axios.patch(`${API_URL_WEB}/${id}`, categories, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const deleteCategories = (id) => {
    const token = localStorage.getItem('token');

    return axios.delete(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const updateActive = (id, bannerProduct) => {
    const token = localStorage.getItem('token');

    return axios.patch(API_URL_WEB + `/active-category/${id}`,
        bannerProduct, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

